import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined'
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useColorScheme } from '@mui/material/styles'

/**
 * Alterna claro/escuro.
 *
 * O escuro é o padrão (projetor de sala de reunião); o claro existe para sala
 * clara. O MUI persiste a escolha em `localStorage` sob a chave configurada no
 * `ThemeProvider`.
 */
export function ThemeToggle() {
  const { mode, setMode } = useColorScheme()

  // Antes da hidratação o modo é indefinido; renderizar nada evita o piscar.
  if (!mode) return null

  const isDark = mode === 'dark'

  return (
    <Tooltip title={isDark ? 'Usar tema claro' : 'Usar tema escuro'}>
      <IconButton
        onClick={() => setMode(isDark ? 'light' : 'dark')}
        aria-label={isDark ? 'Usar tema claro' : 'Usar tema escuro'}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  )
}
